export const GET_ADMIN_INTERNAL_USERS = "GET_ADMIN_INTERNAL_USERS";
export const GET_ADMIN_INTERNAL_USERS_SUCCESS = "GET_ADMIN_INTERNAL_USERS_SUCCESS";
export const GET_ADMIN_INTERNAL_USERS_ERROR = "GET_ADMIN_INTERNAL_USERS_ERROR";

export const GET_ALL_ADMIN_EMPLOYEES = "GET_ALL_ADMIN_EMPLOYEES";
export const GET_ALL_ADMIN_EMPLOYEES_SUCCESS = "GET_ALL_ADMIN_EMPLOYEES_SUCCESS";
export const GET_ALL_ADMIN_EMPLOYEES_ERROR = "GET_ALL_ADMIN_EMPLOYEES_ERROR";

export const CREATE_ADMIN_INTERNAL_USER = "CREATE_ADMIN_INTERNAL_USER";
export const CREATE_ADMIN_INTERNAL_USER_SUCCESS = "CREATE_ADMIN_INTERNAL_USER_SUCCESS";
export const CREATE_ADMIN_INTERNAL_USER_ERROR = "CREATE_ADMIN_INTERNAL_USER_ERROR";

export const CREATE_BULK_ADMIN_INTERNAL_USER = "CREATE_BULK_ADMIN_INTERNAL_USER";
export const CREATE_BULK_ADMIN_INTERNAL_USER_SUCCESS = "CREATE_BULK_ADMIN_INTERNAL_USER_SUCCESS";
export const CREATE_BULK_ADMIN_INTERNAL_USER_ERROR = "CREATE_ADMIN_INTERNAL_USER_ERROR";

export const MODIFY_ADMIN_INTERNAL_USER = "MODIFY_ADMIN_INTERNAL_USER";
export const MODIFY_ADMIN_INTERNAL_USER_SUCCESS = "MODIFY_ADMIN_INTERNAL_USER_SUCCESS";
export const MODIFY_ADMIN_INTERNAL_USER_ERROR = "MODIFY_ADMIN_INTERNAL_USER_ERROR";

export const MODIFY_BULK_ADMIN_INTERNAL_USER = "MODIFY_BULK_ADMIN_INTERNAL_USER";
export const MODIFY_BULK_ADMIN_INTERNAL_USER_SUCCESS = "MODIFY_BULK_ADMIN_INTERNAL_USER_SUCCESS";
export const MODIFY_BULK_ADMIN_INTERNAL_USER_ERROR = "MODIFY_BULK_ADMIN_INTERNAL_USER_ERROR";

export const DELETE_ADMIN_INTERNAL_USER = "DELETE_ADMIN_INTERNAL_USER";
export const DELETE_ADMIN_INTERNAL_USER_SUCCESS = "DELETE_ADMIN_INTERNAL_USER_SUCCESS";
export const DELETE_ADMIN_INTERNAL_USER_ERROR = "DELETE_ADMIN_INTERNAL_USER_ERROR";

export const DELETE_BULK_ADMIN_INTERNAL_USER = "DELETE_BULK_ADMIN_INTERNAL_USER";
export const DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS = "DELETE_BULK_ADMIN_INTERNAL_USER_SUCCESS";
export const DELETE_BULK_ADMIN_INTERNAL_USER_ERROR = "DELETE_BULK_ADMIN_INTERNAL_USER_ERROR";

export const RESEND_ADMIN_INTERNAL_USER_INVITE = "RESEND_ADMIN_INTERNAL_USER_INVITE";
export const RESEND_ADMIN_INTERNAL_USER_INVITE_SUCCESS = "RESEND_ADMIN_INTERNAL_USER_INVITE_SUCCESS";
export const RESEND_ADMIN_INTERNAL_USER_INVITE_ERROR = "RESEND_ADMIN_INTERNAL_USER_INVITE_ERROR";
export const RESET_INVITE_SENT_TO = "RESET_INVITE_SENT_TO";

export const BULK_EDIT_ADMIN_INTERNAL_USERS = "BULK_EDIT_ADMIN_INTERNAL_USERS";
export const BULK_EDIT_ADMIN_INTERNAL_USERS_SUCCESS = "BULK_EDIT_ADMIN_INTERNAL_USERS_SUCCESS";
export const BULK_EDIT_ADMIN_INTERNAL_USERS_ERROR = "BULK_EDIT_ADMIN_INTERNAL_USERS_ERROR";
export const GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS = "GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS";
export const GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_SUCCESS = "GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_SUCCESS";
export const GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_ERROR = "GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS_ERROR";
export const PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT = "PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT";
export const PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_SUCCESS = "PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_SUCCESS";
export const PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_ERROR = "PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT_ERROR";
export const RESET_ADMIN_INTERNAL_USERS_BULK_EDIT_PREVIEW = "RESET_ADMIN_INTERNAL_USERS_BULK_EDIT_PREVIEW";
